export const SITE = {
  name: "Vision Glass Care",
  phoneDisplay: "(225) 777-9747",
  phoneTel: "+12257779747",
  phoneSms: "+12257779747",
  city: "Baton Rouge, Louisiana",
  hours: "8 AM – 8 PM, Daily",
  email: "",
  facebookUrl:
    "https://www.facebook.com/share/1CwnVTzDRx/?mibextid=wwXIfr",
  instagramUrl:
    "https://www.instagram.com/visionglasscare?igsh=YXlqOTU4MXYzazJv&utm_source=qr",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_sparkling-windows-br/artifacts/k0c0dkia_EB31B81C-26BD-4269-89B7-93DE25097B13.png",
  footerLogoUrl:
    "https://customer-assets.emergentagent.com/job_sparkling-windows-br/artifacts/k0c0dkia_EB31B81C-26BD-4269-89B7-93DE25097B13.png",
  areas: [
    "Baton Rouge",
    "Denham Springs",
    "Shenandoah",
    "Walker",
    "Watson",
    "& surrounding areas",
  ],
  // Owner-supplied job photos
  photos: {
    heroExterior:
      "https://customer-assets.emergentagent.com/job_sparkling-windows-br/artifacts/0xmhqbmv_IMG_6806.jpeg",
    detailExterior:
      "https://customer-assets.emergentagent.com/job_sparkling-windows-br/artifacts/p2b159ej_IMG_6805.jpeg",
    interiorBlinds:
      "https://customer-assets.emergentagent.com/job_sparkling-windows-br/artifacts/cfwk8uqx_IMG_6803.jpeg",
    trackBeforeAfter:
      "https://customer-assets.emergentagent.com/job_sparkling-windows-br/artifacts/06144swg_IMG_6802.jpeg",
  },
};
